import { IKeepWatchingState } from '../../types/interfaces/states';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { IRailShow } from '../../types/interfaces/rail';
import KeepWatching from '../../classes/keepWatching';
import Rail from '../../classes/rail';

const initialState = {
  data: [],
  rail: undefined,
  initialized: false
} as IKeepWatchingState;

const keepWatchingSlice = createSlice({
  name: 'keepWatching',
  initialState,
  reducers: {
    setKeepWatchingData: (state, action: PayloadAction<{ shows: IRailShow[], rail?: Rail }>) => {
      state.initialized = true
      state.rail = action.payload.rail
      state.data = action.payload.shows.map((item) => {
        return new KeepWatching(
          item.eventId,
          parseInt(item?.seguirViendoSeconds || '0')
        );
      });
    },
    addKeepWatchingItem: (
      state,
      action: PayloadAction<{ id: string; mark: number }>
    ) => {
      state.initialized = true
      state.data.push(action.payload);
    },
    updateKeepWatchingItem: (
      state,
      action: PayloadAction<{ id: string; mark: number }>
    ) => {
      const index = state.data.findIndex((item) => {
        return item.id === action.payload.id;
      });
      if (index !== -1) {
        state.data[index].mark = action.payload.mark;
      }
    },
    removeKeepWatchingItem: (state, action: PayloadAction<string>) => {
      const index = state.data.findIndex((item) => {
        return item.id === action.payload;
      });
      if (index !== -1) {
        state.data.splice(index, 1);
      }
    },
  },
});

const { actions, reducer: keepWatchingReducer } = keepWatchingSlice;
export const {
  setKeepWatchingData,
  addKeepWatchingItem,
  removeKeepWatchingItem,
  updateKeepWatchingItem,
} = actions;
export const keepWatchingSelector = (state: RootState) => state.keepWatching;
export default keepWatchingReducer;
